export enum MerchantDashboardWidgetType {
  MiniView = "mini-view",
}
